import { TENANT_AT, TENANT_COM, TENANT_FR, TENANT_IT } from 'shared/consts'
import { TYPE_CSW_ON_SERP } from 'shared/consts/crosssellWidgets'
import {
  CSW_ON_HOMEPAGE,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

const getWid = () => {
  const {
    tenant,
    crosssell: { widgets },
  } = store.getState()?.publicRuntimeConfig.publicConfig || {}

  switch (tenant) {
    case TENANT_AT:
      return 407
    case TENANT_COM:
      return 406
    case TENANT_FR:
      return 286
    case TENANT_IT:
      return widgets[TYPE_CSW_ON_SERP]
  }
  return null
}

export default () => {
  const { isEnabled, variant } = getExperimentOnClient(CSW_ON_HOMEPAGE)

  const crosssell = document.querySelector(`.wid-${getWid()}`)

  if (crosssell && isEnabled && variant === EXPERIMENT_VARIATION.V1) {
    crosssell.classList.remove('u-hidden')
  }
}
